import { render, staticRenderFns } from "./RiskMailboxOnline.vue?vue&type=template&id=7e471cb3&scoped=true&"
import script from "./RiskMailboxOnline.vue?vue&type=script&lang=js&"
export * from "./RiskMailboxOnline.vue?vue&type=script&lang=js&"
import style0 from "./RiskMailboxOnline.vue?vue&type=style&index=0&id=7e471cb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e471cb3",
  null
  
)

export default component.exports